/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import NomineeForm from './NomineeForm';

export default NomineeForm;
